import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { Site, SiteFormData } from "./site";
import { siteService } from "./siteService";
import toast from "react-hot-toast";
import { DEFAULT_PAGINATION } from "../../constants/pagination";

export interface SiteState {
  sites: Site[];
  selectedSite: Site | null;
  loading: boolean;
  error: string | null;
}

const initialState: SiteState = {
  sites: [],
  selectedSite: null,
  loading: false,
  error: null,
};

export const fetchSites = createAsyncThunk(
  "site/fetchsites",
  async (params: { 
      customerId?: string; 
      siteId?: string; 
      page?: number; 
      limit?: number; 
      search?: string; 
      status?: string;
    },
    { rejectWithValue }) => {
    try {
      let { customerId, siteId } = params || {};
      // let apiParams = {};
      let apiParams: { [key: string]: any } = {};
      // if (customerId) {
      //   apiParams = { customer_id: customerId };
      // }
      // if (siteId) {
      //   apiParams = { ...apiParams, site_id: siteId };
      // }

      // let apiParams: { [key: string]: any } = {};
      if (customerId) apiParams.customer_id = customerId;
      if (siteId) apiParams.site_id = siteId;
      if (params?.page) apiParams.page = params.page;
      if (params?.limit) apiParams.limit = params.limit;
      if (params?.search) apiParams.search = params.search;

      const response = await siteService.getSites(apiParams);
      console.log("Fetched sites Data from siteSlice:", response.data);

      // Transform sites data to match the expected interface
      // Handle both nested and direct response structures
      const sites = response.data?.sites || response.data || [];
      console.log("🔍 Raw sites from API:", sites);
      console.log("🔍 First site customer_id:", sites[0]?.customer_id);
      console.log("🔍 First site customer object:", sites[0]?.customer);
      const transformedSites = sites.map((site: any) => ({
        id: site.id,
        name: site.name,
        address: site.address || "",
        city: site.city || "",
        state: site.state || "",
        zipCode: site.zip_code || site.zipCode || "",
        contactPerson: site.contact_person || site.contactPerson || "",
        contactPhone: site.contact_phone || site.contactPhone || "",
        status: site.status || "active",
        notes: site.notes || "",
        customerId:
          site.customer?.customerId || site.customerId || site.customer_id,
        customer: site.customer
          ? {
              id: site.customer.id || site.customer.customerId,
              name: site.customer.name || site.customer.customerName,
              code: site.customer.code || site.customer.customerCode,
            }
          : undefined,
        createdAt: site.created_at || site.createdAt,
        updatedAt: site.updated_at || site.updatedAt,
        namePlate:site.namePlate || site.name_plate,
        totalOrder: site.total_order || site.totalOrder || 0,
        completedOrder: site.completed_order || site.completedOrder || 0,
        pendingOrder: site.pending_order || site.pendingOrder || 0,
      }));

      console.log("Transformed sites:", transformedSites);
      console.log(
        "🔍 Transformed site customerId:",
        transformedSites[0]?.customerId
      );
      console.log(
        "🔍 Transformed site customer object:",
        transformedSites[0]?.customer
      );
      // return transformedSites;
      return {                
        sites: transformedSites,
        pagination: response.pagination || {
            page: DEFAULT_PAGINATION.page,
            limit: DEFAULT_PAGINATION.limit,
            pages: 1,
            total: transformedSites.length,
        }
      };
    } catch (error: any) {
      console.log("error=====>", error);
      // return rejectWithValue(
      //     error.response?.data?.message || "Failed to fetch site"
      // )
    }
  }
);

export const fetchSitesById = createAsyncThunk(
  "site/fetchSitesById",
  async (siteId: string, { rejectWithValue }) => {
    try {
      const response = await siteService.getSiteById(siteId);
      if (response.success) {
        const apiSite = response.data;
        const transformedsite: Site = {
          id: apiSite.id,
          name: apiSite.name,
          address: apiSite.address,
          namePlate:apiSite.namePlate,
          city: apiSite.city,
          state: apiSite.state,
          zipCode: apiSite.zipCode,
          contactPerson: apiSite.contactPerson,
          contactPhone: apiSite.contactPhone,
          status: apiSite.status,
          notes: apiSite.notes,
          customerId: apiSite.customerId,
          createdAt: apiSite.createdAt,
          updatedAt: apiSite.updatedAt,
          totalOrder: apiSite.totalOrder || 0,
          completedOrder: apiSite.completedOrder || 0,
          pendingOrder: apiSite.pendingOrder || 0,
        };
        return transformedsite;
      } else {
        return rejectWithValue("Falied to fetch site");
      }
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch site"
      );
    }
  }
);

export const createSite = createAsyncThunk(
  "site/createSite",
  async (siteData: SiteFormData, { rejectWithValue }) => {
    try {
      const response = await siteService.createSite(siteData);
      if (response.success) {
        const apiSite = response.data;
        const transformedSite: Site = {
          id: apiSite.id,
          name: apiSite.name,
          namePlate:apiSite.namePlate,
          address: apiSite.address,
          city: apiSite.city,
          state: apiSite.state,
          zipCode: apiSite.zipCode,
          contactPerson: apiSite.contactPerson,
          contactPhone: apiSite.contactPhone,
          status: apiSite.status,
          notes: apiSite.notes,
          customerId: apiSite.customerId,
          createdAt: apiSite.createdAt,
          updatedAt: apiSite.updatedAt,
          totalOrder: apiSite.totalOrder || 0,
          completedOrder: apiSite.completedOrder || 0,
          pendingOrder: apiSite.pendingOrder || 0,
        };
        return transformedSite;
      } else {
        return rejectWithValue("Failed to create site");
      }
    } catch (error: any) {
      console.error("Create site error:", error);
      // Return the full error response to access errors array
      if (error.response?.data) {
        return rejectWithValue(error.response.data);
      }
      const errorMessage = error.message || "Failed to create site";
      return rejectWithValue({ message: errorMessage, errors: [errorMessage] });
    }
  }
);

export const editSite = createAsyncThunk(
  "site/editSite",
  async (
    { id, siteData }: { id: string; siteData: SiteFormData },
    { rejectWithValue }
  ) => {
    try {
      const response = await siteService.updateSite(id, siteData);
      if (response.success) {
        const apiSite = response.data;
        const transformedSite: Site = {
          id: apiSite.id,
          name: apiSite.name,
          address: apiSite.address,
          namePlate:apiSite.namePlate,
          city: apiSite.city,
          state: apiSite.state,
          zipCode: apiSite.zipCode,
          contactPerson: apiSite.contactPerson,
          contactPhone: apiSite.contactPhone,
          status: apiSite.status,
          notes: apiSite.notes,
          customerId: apiSite.customerId,
          createdAt: apiSite.createdAt,
          updatedAt: apiSite.updatedAt,
          totalOrder: apiSite.totalOrder || 0,
          completedOrder: apiSite.completedOrder || 0,
          pendingOrder: apiSite.pendingOrder || 0,
        };
        return transformedSite;
      } else {
        return rejectWithValue("Failed to update site");
      }
    } catch (error: any) {
      console.error("Update site error:", error);
      // Return the full error response to access errors array
      if (error.response?.data) {
        return rejectWithValue(error.response.data);
      }
      const errorMessage = error.message || "Failed to update site";
      return rejectWithValue({ message: errorMessage, errors: [errorMessage] });
    }
  }
);

export const removeSite = createAsyncThunk(
  "site/removeSite",
  async (id: string, { rejectWithValue }) => {
    try {
      await siteService.deleteSite(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete site"
      );
    }
  }
);

const siteSlice = createSlice({
  name: "sites",
  initialState,
  reducers: {
    setSelectedSite: (state, action: PayloadAction<Site | null>) => {
      state.selectedSite = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.loading = false;
        // state.sites = action.payload;
        state.sites = action.payload?.sites;
        state.pagination = action.payload?.pagination
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        // Error toast is already handled by errorHandlingService in enhancedApiClient
      });

    builder
      .addCase(fetchSitesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSitesById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSite = action.payload;
      })
      .addCase(fetchSitesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        // Error toast is already handled by errorHandlingService in enhancedApiClient
      });

    // createSite
    builder
      .addCase(createSite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSite.fulfilled, (state, action) => {
        state.loading = false;
        state.sites.unshift(action.payload);
        toast.success("Site created successfully");
      })
      .addCase(createSite.rejected, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        // Handle both string and object error responses
        if (typeof payload === 'string') {
          state.error = payload;
        } else if (payload?.errors && Array.isArray(payload.errors)) {
          state.error = payload.errors.join(', ');
        } else {
          state.error = payload?.message || 'Failed to create site';
        }
        // Error toast is already handled by errorHandlingService in enhancedApiClient
      });

    // editSite
    builder
      .addCase(editSite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editSite.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.sites.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) {
          state.sites[index] = action.payload;
        }
        if (state.selectedSite?.id === action.payload.id) {
          state.selectedSite = action.payload;
        }
        toast.success("Site updated successfully");
      })
      .addCase(editSite.rejected, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        // Handle both string and object error responses
        if (typeof payload === 'string') {
          state.error = payload;
        } else if (payload?.errors && Array.isArray(payload.errors)) {
          state.error = payload.errors.join(', ');
        } else {
          state.error = payload?.message || 'Failed to update site';
        }
        // Error toast is already handled by errorHandlingService in enhancedApiClient
      });
    // removeCustomer
    builder
      .addCase(removeSite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeSite.fulfilled, (state, action) => {
        state.loading = false;
        state.sites = state.sites.filter((c) => c.id !== action.payload);
        if (state.selectedSite?.id === action.payload) {
          state.selectedSite = null;
        }
        toast.success("Customer deleted successfully");
      })
      .addCase(removeSite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        // Error toast is already handled by errorHandlingService in enhancedApiClient
      });
  },
});

export const { setSelectedSite } = siteSlice.actions;

//selectors
export const selectSites = (state: RootState) => state.sites.sites;
console.log('selectSites', selectSites)
// console.log('selectSites state', state.sites)
export const selectSelectedSite = (state: RootState) =>
  state.sites.selectedSite;
export const selectSiteLoading = (state: RootState) => state.sites.loading;
export const selectSiteError = (state: RootState) => state.sites.error;
export const selectSitePagination = (state: RootState) => state.sites.pagination
// export{
//     fetchSites,
//     fetchSitesById,
//     createSite,
//     editSite,
//     removeSite
// }

export default siteSlice.reducer;